import React, { useMemo } from 'react';
import Page from 'src/components/Page';
import { Box, Container } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as breadcrumbs from 'src/utils/breakcrumbs';
import { useParams } from 'react-router-dom';
import CategoryForm from './form/CategoryForm';

const CategoryFormView = ({ title }) => {
  const { id } = useParams();
  const pageBreadcrumbs = useMemo(
    () =>
      breadcrumbs.buildWithDashboard([
        {
          link: '/app/categories',
          label: 'Categories',
        },
        {
          label: `${id ? 'Edit' : 'Create'} category`,
        },
      ]),
    []
  );

  return (
    <Page title={title} breadcrumbs={pageBreadcrumbs}>
      <Container maxWidth="lg">
        <Box>
          <CategoryForm editId={id} />
        </Box>
      </Container>
    </Page>
  );
};

CategoryFormView.propTypes = {
  title: PropTypes.string.isRequired,
};

export default CategoryFormView;
